/* Le ultime modifiche a listino e catalogo, per il titolare.
 *
 * Dal 16 ottobre 2026 le fa chi fattura (tariffe, codici, prezzi e frasi per la fattura): il titolare
 * non le deve chiedere, le rilegge qui. Sta in Gestione, che e' solo sua, e chiusa di default: e' una
 * verifica a campione, non una schermata da guardare ogni giorno.
 */

import { controllo } from "../api";
import { useCarica } from "../carica";
import { conta, type ModificaListino } from "../dominio";

function quando(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("it-IT", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function ModificheListino() {
  const m = useCarica<ModificaListino[]>(() => controllo.modificheListino(), []);
  if (m.errore) {
    return (
      <p className="errore" role="alert">
        {m.errore}
      </p>
    );
  }
  if (m.dati === undefined) return null;
  if (m.dati.length === 0) {
    return <p className="narrativa">Nessuna modifica a listino e catalogo, finora.</p>;
  }
  return (
    <details className="modifiche-listino">
      <summary>Ultime modifiche a listino e catalogo ({conta(m.dati.length, "voce", "voci")})</summary>
      <ul>
        {m.dati.map((r, indice) => (
          <li key={`${r.istante}-${indice}`}>
            <strong>{r.cosa}</strong> · {r.chi} · {quando(r.istante)}
            <span className="narrativa">{r.dettaglio}</span>
          </li>
        ))}
      </ul>
    </details>
  );
}
